import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import Tools from '@/components/tools/Tools.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
// import {mask} from 'vue-the-mask'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin.js'
const name = 'CollaboratorTableTravelExpense'

export default {
  name,
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },

  props: { },

  updated () { },

  data () {
    return {
      ArrayPrimeiroAdiantamento: [],
      dataSearch: localStoreHelper.viagem.colaborador() || {}
    }
  },
  mounted () {
    this.Onload()
  },

  methods: {
    Onload () {
      loading.push()
      // ZC-31: o backend passou a filtrar empresa SEMPRE (nao condicional), como o gemeo do
      // Diversos ja fazia em FirstAdvanceMiscellaneous.js. Sem esta linha a aba nao lista nada —
      // e falha fechada de proposito: antes, sem empresa, ela misturava as 10 empresas que tem
      // primeiro adiantamento em producao.
      this.dataSearch.EmpresaId = this.CompanySelected
      TravelExpenseRepository.GetPrimeiroAdiantamento(this.$refs.tableGridPrimeiroAdiantamento.pagingLimit, this.$refs.tableGridPrimeiroAdiantamento.pagingIndex, this.dataSearch)
        .then((Response) => {
          this.ArrayPrimeiroAdiantamento = Response.data.data
          this.$refs.tableGridPrimeiroAdiantamento.LoadAllByData(Response)
          loading.close()
        })
        .catch((Error) => {
          loading.pop()
          toast.error('error!')
        })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    formataData (value) {
      if (value != null) {
        var data = new Date(value)
        var dia = data.getDate()
        var mes = data.getMonth() + 1
        var ano = data.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelexpensezpag/components/Tabs/AdvanceFirstTrip/AdvanceFirstTrip.js